<template>
  <span class="wrapper" :class="{ 'flex-end': $store.state.session.user.UserID === message.From }">
    <div
      class=""
      :class="{
        messageBalloonMainReverse: $store.state.session.user.UserID === message.From,
        messageBalloonMain: $store.state.session.user.UserID !== message.From
      }"
    >
      <!-- <div class="spacer" v-if="$store.state.session.user.UserID === message.From" /> -->
      <div
        :class="{
          speechBubbleTailedLeft: $store.state.session.user.UserID !== message.From && !message.continueFromSameBuddy,
          speechBubbleNonTailedLeft: $store.state.session.user.UserID !== message.From && message.continueFromSameBuddy,
          speechBubbleTailedRight: $store.state.session.user.UserID === message.From && !message.continueFromSameBuddy,
          speechBubbleNonTailedRight: $store.state.session.user.UserID === message.From && message.continueFromSameBuddy
        }"
      >
        <ForwardedMessageRow v-if="message.isForwarded" />
        <RepliedMessageRow v-if="message.ReplyMessage" :message="message.ReplyMessage" />
        <div class="senderName" :style="{ color: userColor(message.From) }" v-if="message.isGroup === true && $store.state.session.user.UserID !== message.From && !message.continueFromSameBuddy">
          {{ getUserNameDisplay(message.From) }}
        </div>

        <ReactionPicker :visible="showReactionPicker" @select="onToggleReaction" @close="closeReactionPicker" />
        <MessageMenuDropDown :message="message" @open-reactions="openReactionPicker" />

        <audio :id="id" class="audioPlayer" controls preload="none" @play="pauseOtherAudios(id)" style="width:480px;">
          <source :src="audio" type="audio/mp4" />
        </audio>
        <MessageBalloonInfoRow :message="message" />
      </div>

      <MessageReactions :reactions="message.Reactions" :message="message" @toggle-reaction="onToggleReaction" @open-picker="openReactionPicker" />

      <!-- <div class="spacer" v-if="$store.state.session.user.UserID !== message.From" /> -->
    </div>
  </span>
</template>

<script>
import ForwardedMessageRow from './common/ForwardedMessageRow.vue'
import RepliedMessageRow from './common/RepliedMessageRow.vue'
import MessageBalloonInfoRow from './common/MessageBalloonInfoRow.vue'
import MessageMenuDropDown from './common/MessageMenuDropDown.vue'
import MessageReactions from './common/MessageReactions.vue'
import ReactionPicker from './common/ReactionPicker.vue'

import { messageMixin } from '@/mixins/messageMixin.js'

export default {
  components: {
    ForwardedMessageRow,
    RepliedMessageRow,
    MessageBalloonInfoRow,
    MessageMenuDropDown,
    MessageReactions,
    ReactionPicker
  },
  data() {
    return {
      savedID: '',
      showReactionPicker: false
    }
  },
  mixins: [messageMixin],
  computed: {
    id() {
      this.savedID = this.$uuid.v4()
      return this.savedID
    },
    audio() {
      if (this.message.mv <= 1) {
        return this.message.MediaURLs[0]
      } else {
        let key = '6a61e395-b49a-4468-bee0-27644e95308f'
        var iv = key
          .split('')
          .reverse()
          .join('')
        let encryptedBody = this.ewk(this.message.MediaURLs[0], key, iv)
        return process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + this.message.MediaURLs[0] + '&s=' + encodeURIComponent(encryptedBody)
      }
    }
  },
  props: {
    message: {
      type: Object,
      default: function() {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },

  methods: {
    onToggleReaction (emoji) {
      this.toggleReaction(this.message, emoji)
      this.showReactionPicker = false
    },
    openReactionPicker () {
      this.showReactionPicker = true
    },
    closeReactionPicker () {
      this.showReactionPicker = false
    },
    onlyPlayOneIn(container) {
      // container.addEventListener("play", function (event) {
      //   audio_elements = container.getElementsByTagName("audio")
      //   for (i = 0; i < audio_elements.length; i++) {
      //     audio_element = audio_elements[i];
      //     if (audio_element !== event.target) {
      //       audio_element.pause();
      //     }
      //   }
      // }, true);
    },
    pauseOtherAudios(id) {
      const audios = document.querySelectorAll('audio')
      for (const audio of audios) {

        if (audio.id !== id) {
          audio.pause()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../../../../style/messageBalloon';

.audioPlayer:focus {
  outline: none;
}
</style>
